import './index.css';
import { isMobileBrowser } from '../../utilities/helper';
import Constants from '../../constants';
import View from '../view';
import React from 'react';
interface Props {
  children?: object;
  backgroundColor?: any;
}

const MobileWrapper = ({ children, backgroundColor }: Props) => {
  return (
    <View className="mobile-wrapper-container">
      <View
        style={{
          width: isMobileBrowser ? '100%' : '550px',
          minWidth: isMobileBrowser ? '100%' : '550px',
          backgroundColor: backgroundColor,
          height: '100%'
        }}>
        {children}
      </View>
      {!isMobileBrowser && (
        <img
          style={{
            flexGrow: 1
          }}
          className="mobile-image-container"
          src={`${Constants.Images.WebPoster}`}
        />
      )}
    </View>
  );
};
MobileWrapper.defaultProps = {
  backgroundColor: '#000'
};
export default React.memo(MobileWrapper);
